import { Controller } from "@hotwired/stimulus"

// The Gallery table's selection: the "N selected" bar, the select-all box
// (checked, unchecked or mixed), and shift-click to select a range. The
// checkboxes themselves are plain form inputs; submitting the form deletes.
export default class extends Controller {
  static targets = ["box", "all", "bar", "count"]

  connect() {
    this.last = null
    this.refresh()
  }

  pick(event) {
    const box = event.currentTarget
    if (event.shiftKey && this.last && this.last !== box) {
      const boxes = this.boxTargets
      const [from, to] = [boxes.indexOf(this.last), boxes.indexOf(box)].sort((a, b) => a - b)
      boxes.slice(from, to + 1).forEach((b) => { b.checked = box.checked })
    }
    this.last = box
    this.refresh()
  }

  toggleAll() {
    this.boxTargets.forEach((b) => { b.checked = this.allTarget.checked })
    this.refresh()
  }

  clear() {
    this.boxTargets.forEach((b) => { b.checked = false })
    this.refresh()
  }

  refresh() {
    const chosen = this.boxTargets.filter((b) => b.checked).length
    const total = this.boxTargets.length
    if (this.hasAllTarget) {
      this.allTarget.checked = total > 0 && chosen === total
      this.allTarget.indeterminate = chosen > 0 && chosen < total
    }
    this.boxTargets.forEach((b) => b.closest("tr")?.classList.toggle("is-selected", b.checked))
    if (this.hasBarTarget) this.barTarget.hidden = chosen === 0
    if (this.hasCountTarget) this.countTarget.textContent = `${chosen} selected`
    this.element.dataset.turboConfirm = `Delete ${chosen} ${chosen === 1 ? "item" : "items"}? This can't be undone.`
  }
}
